<template>
  <div class="l-input" :class="{ 'l-input--prefix': this.$slots.prefix, 'l-input--suffix': this.$slots.suffix }">
    <div v-if="this.$slots.prefix" class="l-input__prefix">
      <slot name="prefix"/>
    </div>
    <div v-if="this.$slots.suffix" class="l-input__suffix">
      <slot name="suffix"/>
    </div>
    <input
      class="l-input__inner"
      :class="inputClass"
      :name="name"
      :type="type"
      :step="step"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :max="max"
      :min="min"
      :autocomplete="[autocomplete ? 'off' : 'on']"
      @input="onInput">
  </div>
</template>

<script>
export default {
  name: "LInput",
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    type: {
      type: String,
      default: "text"
    },
    step: {
      type: String,
      default: "text"
    },
    value: [String, Number, Boolean],
    name: String,
    readonly: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    min: Number,
    max: Number,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 3
    },
    inputClass: {
      type: String,
      default: "text-xs"
    }
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    }
  }
};
</script>

<style lang="postcss">
.l-input {
  @apply relative inline-block w-full;
  @apply text-xs text-bluegray-300;
  outline: 0;
}
.l-input .l-input__inner {
  @apply relative inline-block w-full;
  @apply text-bluegray-300;
  @apply border border-gray-500 rounded outline-none m-0 pt-3 pb-3 pl-1 pr-1 bg-transparent h-8;

  box-sizing: border-box;
  -webkit-appearance: textfield;
  -moz-appearance:textfield;
}
.l-input .l-input__inner:focus {
  @apply border-pastel-green-500;
}

.l-input .l-input__inner[type=number]:invalid {
  @apply border border-gray-500 rounded outline-none m-0 p-0 pl-1 pr-1 bg-pink-300 h-8;  
  background-color: pink;  
  box-sizing: border-box;
  -webkit-appearance: textfield;
  -moz-appearance:textfield;
  box-shadow: none;
}
.l-input .l-input__inner[type=number]:valid {
  @apply border border-gray-500 rounded outline-none m-0 p-0 pl-1 pr-1 bg-transparent h-8;
  box-shadow: none;
}


.l-input .l-input__prefix,
.l-input .l-input__suffix {
  @apply absolute w-10 flex items-center justify-center z-10;
  top: 0;
  bottom: 0;
}
.l-input .l-input__prefix {
  left: 0;
}
.l-input .l-input__suffix {
  right: 0;
}

.l-input--prefix .l-input__inner {
  padding-left: 40px;
}
.l-input--suffix .l-input__inner {
  padding-right: 40px;
}
</style>
